import styled from 'styled-components'

import { COLORS, THEME, transformToREM } from '../../styles'

const Styled = styled.div`
  position: relative;
  width: ${({ containerSize }) => transformToREM(containerSize || 48)};
  height: ${({ containerSize }) => transformToREM(containerSize || 48)};
  overflow: hidden;
`
Styled.circle = styled.span`
  display: inline-block;
  border-radius: 9999px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${({ isDark }) => (isDark ? COLORS.white : COLORS.black)};
  transform: ${({ isDark }) => (isDark ? 'scale(1)' : 'scale(0.5)')};
  transform-origin: center center;
  /* stylelint-disable-next-line declaration-property-value-disallowed-list */
  transition: all 0.2s;
`
Styled.cover = styled.span`
  display: inline-block;
  border-radius: 9999px;
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  right: 0;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || THEME.COLORS.background.primary};
  transform: ${({ isDark }) =>
    isDark ? 'translate(25%, -25%)' : 'translate(100%, -100%)'};
  transition:
    transform 0.2s,
    background-color 0s;
`
Styled.ray1 = styled.span`
  display: inline-block;
  transform: ${({ isDark }) => (isDark ? 'scale(0)' : 'scale(1)')};
  transform-origin: center center;
  width: 15%;
  height: 15%;
  border-radius: 9999px;
  background-color: ${COLORS.black};
  position: absolute;
  top: 0;
  left: 42.5%;
  /* stylelint-disable-next-line */
  transition: all 0.2s;
`
Styled.ray2 = styled.span`
  display: inline-block;
  transform: ${({ isDark }) => (isDark ? 'scale(0)' : 'scale(1)')};
  transform-origin: center center;
  width: 15%;
  height: 15%;
  border-radius: 9999px;
  background-color: ${COLORS.black};
  position: absolute;
  left: 0;
  top: 23%;
  /* stylelint-disable-next-line declaration-property-value-disallowed-list */
  transition: all 0.2s;
`
Styled.ray3 = styled.span`
  display: inline-block;
  transform: ${({ isDark }) => (isDark ? 'scale(0)' : 'scale(1)')};
  transform-origin: center center;
  width: 15%;
  height: 15%;
  border-radius: 9999px;
  background-color: ${COLORS.black};
  position: absolute;
  left: 0;
  bottom: 23%;
  /* stylelint-disable-next-line declaration-property-value-disallowed-list */
  transition: all 0.2s;
`
Styled.ray4 = styled.span`
  display: inline-block;
  transform: ${({ isDark }) => (isDark ? 'scale(0)' : 'scale(1)')};
  transform-origin: center center;
  width: 15%;
  height: 15%;
  border-radius: 9999px;
  background-color: ${COLORS.black};
  position: absolute;
  bottom: 0;
  left: 42.5%;
  /* stylelint-disable-next-line declaration-property-value-disallowed-list */
  transition: all 0.2s;
`
Styled.ray5 = styled.span`
  display: inline-block;
  transform: ${({ isDark }) => (isDark ? 'scale(0)' : 'scale(1)')};
  transform-origin: center center;
  width: 15%;
  height: 15%;
  border-radius: 9999px;
  background-color: ${COLORS.black};
  position: absolute;
  right: 0;
  top: 23%;
  /* stylelint-disable-next-line declaration-property-value-disallowed-list */
  transition: all 0.2s;
`
Styled.ray6 = styled.span`
  display: inline-block;
  transform: ${({ isDark }) => (isDark ? 'scale(0)' : 'scale(1)')};
  transform-origin: center center;
  width: 15%;
  height: 15%;
  border-radius: 9999px;
  background-color: ${COLORS.black};
  position: absolute;
  right: 0;
  bottom: 23%;
  /* stylelint-disable-next-line declaration-property-value-disallowed-list */
  transition: all 0.2s;
`

export default Styled
